export type ThemeChoice = 'system' | 'light' | 'dark';

export const THEME_KEY = 'affdice.theme';

/** The key the consoles used before the rename; read once, then retired. */
export const LEGACY_THEME_KEY = 'nexus.theme';

/**
 * The stored choice, or 'system'. A reader who chose a theme before the rename
 * keeps it: the old key is copied to the new one and removed, so the choice
 * survives without the old name lingering in the browser. Storage can refuse
 * (a private window, blocked site data); then the console follows the system.
 * With blocked site data even reading `localStorage` throws, so it is resolved
 * inside the try: a default parameter would run before it, and this is called
 * as the module loads, which would leave every console a blank page.
 */
export function readStoredTheme(given?: Storage): ThemeChoice {
  try {
    const storage = given ?? globalThis.localStorage;
    let v = storage?.getItem(THEME_KEY) ?? null;
    if (v === null) {
      const legacy = storage?.getItem(LEGACY_THEME_KEY) ?? null;
      if (legacy !== null) {
        v = legacy;
        // Only a valid choice is worth carrying over; either way the old key goes.
        if (legacy === 'light' || legacy === 'dark') storage?.setItem(THEME_KEY, legacy);
        storage?.removeItem(LEGACY_THEME_KEY);
      }
    }
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}
